module.exports = __webpack_public_path__ + "static/media/animal_music_band_bass.fa173274.png";